import allowResponseForSmimeItem from '../utils/allowResponseForSmimeItem';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ActionSource } from 'owa-analytics-actions';
import { ClientItemId } from 'owa-client-ids';
import loc, { format } from 'owa-localize';
import { irm_actionNotAllowedOnThisItem } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisitem.locstring.json';
import { itemHeaderForward } from 'owa-locstrings/lib/strings/itemheaderforward.locstring.json';
import { lazyForwardMessage } from 'owa-mail-compose-actions';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { mailStore } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import Item from 'owa-service/lib/contract/Item';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import { action } from 'satcheljs/lib/legacy';

export default action('forwardItem')(async function forwardItem(
    itemId: ClientItemId,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    suppressServerMarkReadOnReplyOrForward: boolean,
    targetWindow?: Window
) {
    const restrictionToConfirm = <IRMRestrictions>{ ForwardAllowed: true };
    const item: Item = mailStore.items.get(itemId.Id);
    const isResponseAllowedForSmimeItem =
        !isSMIMEItem(item) || (await allowResponseForSmimeItem(itemId.Id, loc(itemHeaderForward)));
    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(loc(irm_actionNotAllowedOnThisItem), loc(itemHeaderForward))
        ) &&
        isResponseAllowedForSmimeItem
    ) {
        lazyForwardMessage.importAndExecute(
            itemId,
            actionSource,
            instrumentationContexts,
            suppressServerMarkReadOnReplyOrForward,
            {
                targetWindow: targetWindow,
            }
        );
        mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
    }
});
